import { View, Text, Platform } from "react-native";
import { GuidePageHeader, GuideCard, GuideTip, GuideNav, getGuideNav } from "./_components";

const PAGE_HREF = "/(web)/guide/weekend-mode";

export default function WeekendModePage() {
  if (Platform.OS !== "web") return null;
  const nav = getGuideNav(PAGE_HREF);

  return (
    <View>
      <GuidePageHeader
        icon="calendar"
        title="Familie Weekend"
        subtitle="Het hart van de app: het familie weekend. Alles draait om samen spelen, punten verdienen en herinneringen maken."
        color="#3B82F6"
      />

      {/* Wat is een familie weekend? */}
      <Text className="text-xl font-bold text-gray-900 mb-4">Wat is een familie weekend?</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Het familie weekend is een speciaal evenement dat door de commissie wordt georganiseerd. 
        Tijdens een actief weekend worden teams gevormd, spellen gespeeld en punten verdeeld. 
        Het weekend heeft een eigen agenda met activiteiten, maaltijden en spelletjes.
      </Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Een weekend heeft een tweejaarlijkse cyclus en omvat zowel de "Familie Dag" als het 
        hoofdweekend zelf. Elk weekend heeft een eigen thema, locatie en programma.
      </Text>

      {/* Competitie modus */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Competitie Modus</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Wanneer een weekend actief is, draait de app in competitie modus. Dit betekent:
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="trophy"
          title="Punten verdienen"
          description="Elk spel dat je speelt en elke uitdaging die je voltooit levert punten op voor je team. De puntenverdeling verschilt per spel en moeilijkheidsgraad."
          color="#F59E0B"
        />
        <GuideCard
          icon="podium"
          title="Team Leaderboard"
          description="De teamstand is zichtbaar voor iedereen. Bekijk welk team aan de leiding gaat en hoeveel punten elk team heeft verdiend."
          color="#3B82F6"
        />
        <GuideCard
          icon="time"
          title="Tijdsgebonden spellen"
          description="Sommige spellen zijn alleen beschikbaar tijdens bepaalde tijden van het weekend, ingesteld door de commissie."
          color="#EF4444"
        />
        <GuideCard
          icon="lock-closed"
          title="Weekend-specifieke configuratie"
          description="De commissie kan instellen welke spellen beschikbaar zijn, hoeveel punten ze waard zijn en wanneer ze gespeeld kunnen worden."
          color="#8B5CF6"
        />
      </View>

      <GuideTip title="Wanneer is competitie actief?">
        De competitie is alleen actief als het weekend officieel is gestart door de commissie. 
        Je kunt dit zien aan de banner bovenaan het startscherm en de teamstand die zichtbaar wordt.
      </GuideTip>

      {/* Vrij spelen */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Vrij Spelen</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Buiten een actief weekend (of als de competitie niet actief is) kun je "vrij spelen". 
        Dit betekent dat je alle spellen kunt spelen zonder dat er punten op het spel staan. 
        Perfect om te oefenen of gewoon voor de lol te spelen!
      </Text>

      <GuideTip variant="success" icon="game-controller" title="Vrij spelen leaderboard">
        Ook in vrij spelen modus worden je scores bijgehouden. Er is een apart "vrij spelen" 
        leaderboard waarop je je scores kunt vergelijken met andere familieleden.
      </GuideTip>

      {/* Familie Dag */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Familie Dag</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        De Familie Dag is een korter evenement binnen dezelfde cyclus als het weekend. Het heeft 
        een eigen locatie en programma. De commissie kan de locatie van de Familie Dag apart 
        onthullen, wat voor extra spanning zorgt!
      </Text>

      {/* Locatie onthulling */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Locatie Onthulling</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        De commissie kan ervoor kiezen om de locatie van het weekend of de Familie Dag geheim 
        te houden tot een bepaald moment. Wanneer de locatie wordt onthuld, ontvang je een melding 
        en wordt de locatie zichtbaar op de kaart in de app.
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="eye-off"
          title="Geheim tot onthulling"
          description="De locatie is verborgen en toont alleen een vraagteken. Familieleden kunnen speculeren in de chat!"
          color="#8B5CF6"
        />
        <GuideCard
          icon="eye"
          title="Na onthulling"
          description="Na de onthulling is de locatie zichtbaar op de kaart met het adres en eventueel een routebeschrijving."
          color="#10B981"
        />
      </View>

      <GuideTip icon="sparkles" title="Countdown">
        Soms wordt er een aftelling gebruikt voor de onthulling. Houd de app in de gaten 
        voor een spectaculaire reveal met animatie!
      </GuideTip>

      <GuideNav {...nav} />
    </View>
  );
}
